import { IAbcComponent, StylingMode } from '../abcComponent.model';

export interface IDocumentInput extends IAbcComponent {
  placeholder?: string;
  value?: string;
  disabled?: boolean;
  rtlEnabled?: boolean;
  visible?: boolean;
  buttonList?: DocumentInputButton[];
  setDocumentInputStyle(style?: DocumentInputStyle);
}

export class DocumentInputStyle {
  height: string | number = 25;
  width: string | number = '100%';
  disabled?: boolean;
}

export class DocumentInputButton {
  name: string;
  text: string;
  stylingMode?: StylingMode;
  mode?: ModeDocumentationInput;
  type?: string;
  onClick?(e): void;
}

export enum ModeDocumentationInput {
  Email = 'email',
  Password = 'password',
  Search = 'search',
  Tel = 'tel',
  Text = 'text',
  Url = 'url',
}

export enum StylinMode {
  Outlined = 'outlined',
  Underlined = 'underlined',
  Filled = 'filled',
}
